import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Headers from './Component/Header';
import Footer from './Component/Footer';
import Request from './Component/requestEstimate';
import about from './Component/about.png';
import brand1 from './Component/home/brand1.png';
import brand2 from './Component/home/brand2.png';
import logo from './Component/home/logo512.png';
import chiefLogo from './Component/home/CCMLOGO.png';

function About() {
  // Check if current date is before June 20, 2025 to display anniversary info
  const currentDate = new Date();
  const endDate = new Date('2025-06-20');
  const showAnniversaryInfo = currentDate <= endDate;

  return (
    <div className="modern-ui">
      <Headers />
      
      {/* Modern About Us Header */}
      <section className="py-5">
        <div className="container text-center">
          <h1 className="display-4 fw-bold text-danger mb-2 responsive-text">About Nickle's Flooring</h1>
          <p className="lead mb-0 text-muted responsive-text-sm">GET TO KNOW YOUR CASSVILLE, MO AREA FLOORING EXPERTS</p>
        </div>
      </section>
      
      {/* 35th Anniversary Banner - Only shown if within date range */}
      {showAnniversaryInfo && (
        <section className="py-4 mb-5" style={{background: 'linear-gradient(to right, #803333, #9a4444, #803333)'}}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="bg-white p-4 rounded-3 shadow-lg text-center">
                  <span className="badge bg-danger p-2 rounded-pill fs-5 mb-3">
                    <i className="bi bi-trophy me-2"></i>35 YEARS OF EXCELLENCE
                  </span>
                  <h2 className="display-6 fw-bold text-danger mb-3 responsive-text">Celebrating 35 Years of Service!</h2>
                  <p className="fs-5 mb-4 responsive-text-sm">
                    Since 1990, we've been proudly serving Cassville and the surrounding communities with quality flooring solutions and exceptional customer service.
                  </p>
                  <div className="d-flex justify-content-center align-items-center gap-4 mb-3">
                    <img src={logo} alt="Buffalo Nickel" className="img-fluid" style={{maxWidth: '150px', height: 'auto'}} />
                    <img src={chiefLogo} alt="Chief Construction Management" className="img-fluid" style={{maxWidth: '150px', height: 'auto'}} />
                  </div>
                  <p className="fs-5 mb-0 responsive-text-sm">
                    Join us for our <strong>Anniversary Celebration</strong> on June 13-14, 2025!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      
      {/* Main About Content - Modern Layout */}
      <section className="py-5">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img src={about} alt="Our store and team" className="img-fluid rounded-3 shadow" />
            </div>
            <div className="col-lg-6">
              <div className="p-4 bg-white rounded-3 shadow-sm">
                <h2 className="display-6 fw-bold text-danger mb-4 responsive-text">Serving you and your home for 35 years!</h2>
                <p className="mb-3 responsive-text-sm">
                  Being a family-owned and operated business, we're able to offer you that personal touch you've been looking for. Our goal is to always make all of our customers happy, and we believe in treating each customer like a part of our family.
                </p>
                <p className="mb-3 responsive-text-sm">
                  We look forward to hearing from you soon! And when you're in Cassville we hope you come in and visit.
                </p>
                <p className="mb-4 responsive-text-sm">
                  <strong>Builders & Contractors:</strong> We have a special program in place for your new home construction and full home remodels. Call us today for details!
                </p>
                <a href="/contact" className="btn btn-danger btn-lg rounded-pill px-4">
                  Contact Us <i className="bi bi-arrow-right ms-1"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* New Company Merger Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="card border-0 shadow-sm">
                <div className="card-body p-4 p-md-5">
                  {/* <div className="text-center mb-4">
                    <h2 className="display-6 fw-bold text-danger mb-3 responsive-text">Exciting News: Company Merger!</h2>
                    <p className="fs-5 responsive-text-sm">We're thrilled to announce that Nickle's Flooring has merged with Chief Construction Management</p>
                  </div> */}
                  
                  {/* <div className="row align-items-center g-4">
                    <div className="col-md-6 text-center">
                      <div className="p-3">
                        <img src={logo} alt="Buffalo Nickel Logo" className="img-fluid mb-3" style={{maxWidth: '200px'}} />
                        <h4 className="fs-4 fw-bold text-danger responsive-text">Buffalo Nickel</h4>
                        <p className="responsive-text-sm">Continuing our tradition of quality flooring solutions with the same great service you've come to expect.</p>
                      </div>
                    </div>
                    
                    <div className="col-md-6 text-center">
                      <div className="p-3">
                        <img src={chiefLogo} alt="Chief Construction Management Logo" className="img-fluid mb-3" style={{maxWidth: '200px'}} />
                        <h4 className="fs-4 fw-bold text-danger responsive-text">Chief Construction Management</h4>
                        <p className="responsive-text-sm">Expanding our offerings to include full-service construction management and home improvement.</p>
                      </div>
                    </div>
                  </div> */}
                  
                  <div className="mt-4 text-center">
                    <h3 className="fs-4 fw-bold text-danger mb-3 responsive-text">Our expanded services now include:</h3>
                    <div className="row justify-content-center g-3">
                      <div className="col-md-4 col-sm-6">
                        <div className="p-3 bg-white rounded shadow-sm h-100">
                          <i className="bi bi-droplet-fill text-danger fs-1 mb-2"></i>
                          <h5 className="fw-bold responsive-text-sm">Full Bathroom Remodeling</h5>
                          <p className="small text-muted mb-0">Tubs, faucets, custom showers & more</p>
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-6">
                        <div className="p-3 bg-white rounded shadow-sm h-100">
                          <i className="bi bi-house-door-fill text-danger fs-1 mb-2"></i>
                          <h5 className="fw-bold responsive-text-sm">Kitchen Renovations</h5>
                          <p className="small text-muted mb-0">Cabinets, countertops, sinks & faucets</p>
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-6">
                        <div className="p-3 bg-white rounded shadow-sm h-100">
                          <i className="bi bi-bricks text-danger fs-1 mb-2"></i>
                          <h5 className="fw-bold responsive-text-sm">Construction Services</h5>
                          <p className="small text-muted mb-0">Concrete, asphalt, fencing & more</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Browse Catalog Call-to-Action */}
      <section className="py-5" style={{backgroundColor: '#803333'}}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center text-white">
              <h2 className="display-6 fw-bold mb-3 responsive-text">Serving you and your home</h2>
              <p className="lead mb-4 responsive-text-sm">Browse our extensive catalog of quality flooring options for every room in your home</p>
              <a href="/products" className="btn btn-light btn-lg rounded-pill px-4">
                Browse Our Catalog <i className="bi bi-arrow-right ms-1"></i>
              </a>
            </div>
          </div>
        </div>
      </section>
      
      {/* Request Estimate Section */}
      <Request />
      
      {/* Brands Section */}
      <section className="py-5">
        <div className="container">
          <h2 className="text-center fw-bold mb-4 responsive-text">Featured brands & technologies</h2>
          <div className="row">
            <div className="col-12 mb-4">
              <img src={brand1} alt="Featured brands" className="mx-auto d-block img-fluid" />
            </div>
            <div className="col-12">
              <img src={brand2} alt="Featured brands" className="mx-auto d-block img-fluid" />
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
      
      {/* Custom CSS for modern UI elements */}
      <style jsx="true">{`
        .modern-ui .btn-danger {
          background-color: #803333;
          border-color: #803333;
        }
        .modern-ui .btn-danger:hover {
          background-color: #6a2a2a;
          border-color: #6a2a2a;
        }
        .modern-ui .text-danger {
          color: #803333 !important;
        }
        
        /* Responsive text classes */
        .responsive-text {
          font-size: 1.5rem;
        }
        .responsive-text-sm {
          font-size: 1rem;
        }
        
        /* Responsive typography */
        @media (max-width: 576px) {
          .display-4 {
            font-size: 2rem !important;
          }
          .display-5 {
            font-size: 1.8rem !important;
          }
          .display-6 {
            font-size: 1.5rem !important;
          }
          .fs-4 {
            font-size: 1.1rem !important;
          }
          .fs-5 {
            font-size: 1rem !important;
          }
          .lead {
            font-size: 1rem !important;
          }
          .btn-lg {
            font-size: 0.9rem;
            padding: 0.4rem 1rem !important;
          }
          .responsive-text {
            font-size: 1.2rem !important;
          }
          .responsive-text-sm {
            font-size: 0.85rem !important;
          }
        }
        
        @media (min-width: 577px) and (max-width: 768px) {
          .display-4 {
            font-size: 2.5rem !important;
          }
          .display-5 {
            font-size: 2.2rem !important;
          }
          .display-6 {
            font-size: 1.8rem !important;
          }
          .responsive-text {
            font-size: 1.4rem !important;
          }
          .responsive-text-sm {
            font-size: 0.9rem !important;
          }
        }
      `}</style>
    </div>
  )
}

export default About
